import { useState, useEffect } from 'react'
import { Layout } from '@enterprise-ui/canvas-ui-react'
import { useAuth } from '@praxis/component-auth'
import { TargetLogo } from '@enterprise-ui/canvas-ui-react'
import { MainRouter } from '../globalComponents/MainRouter'
import { Header } from '../globalComponents/Header'
import { SideNavigation } from '../globalComponents/SideNavigation'
import { ToastProvider } from '@enterprise-ui/canvas-ui-react'

export const Main = () => {
  const auth = useAuth()
  const { isAuthenticated, login } = auth

  const [isSideNavOpen, setIsSideNavOpen] = useState(true)
  const handleSideNavToggle = () => {
    setIsSideNavOpen(!isSideNavOpen)
  }

  useEffect(() => {
    if (!isAuthenticated()) {
      try {
        login({ redirect: window.location.href })
      } catch (err) {
        console.error('login() threw an error:', err)
      }
    }
  })

  return (
    <ToastProvider location="top">
      {!isAuthenticated() ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            fontSize: '1rem',
          }}
          data-testid="redirectingToLogin"
        >
          <TargetLogo size="expanded" className="hc-mr-dense" />
          Redirecting to sign-in…
        </div>
      ) : (
        <Layout
          theme="default"
          darkMode="system"
          data-testid="mainAuthenticatedLayout"
        >
          <Header onSideNavToggle={handleSideNavToggle} />
          <SideNavigation
            isOpen={isSideNavOpen}
            onRequestClose={handleSideNavToggle}
          />
          <MainRouter />
        </Layout>
      )}
    </ToastProvider>
  )
}
